import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, Observable, of } from 'rxjs';
import { SharedServiceService } from '../../services/shared-service.service';
import { Questions } from '../../models/questions';
import { LabWork, Meetings } from '../../models/lab-work';

@Injectable({
  providedIn: 'root'
})
export class MemberService {

  private apiBaseUrl: string;

  constructor(private http: HttpClient, private sharedService: SharedServiceService) {
    this.apiBaseUrl = sharedService.baseUrl();
  }


  // Get member by ID
  getMemberById(id: string): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = `${this.apiBaseUrl}members/GetMemberById?memberId=${id}`;
    return this.http.get(url, { headers });
  }

  // Update member details
  updateMember(id: string, memberData: any): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = `${this.apiBaseUrl}members?memberId=${id}`;
    return this.http.put<any>(url, memberData, { headers });
  }

  GetMemberQuestionnaire(id: any): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + 'questionnaires?memberId=' + id;
    return this.http.get(url, { headers });
  }

  saveQuestionaire(questionsData: any) {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + 'questionnaires?memberId';
    return this.http.post<Questions>(url, questionsData, { headers })
  }
  GetLabWork(memberid: any, page: any): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + 'LabWork/GetLabWork?memberId=' + memberid + '&pageNo=' + page + '&pageSize=5';
    return this.http.get<LabWork>(url, { headers });
  }
  GetMeetings(memberid: any): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + 'events/GetEventByMemberId' + '?memberId=' + memberid;
    return this.http.get<Meetings>(url, { headers });
  }
  addProgressPlan(data: any) {
    const headers = this.sharedService.createAuthorizationHeader();
    return this.http.post(this.apiBaseUrl + 'progressNotes', data, { headers });
  }

  getProgressPlan(id: any, page: any) {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + 'progressNotes/GetProgressNotesByMemberId?memberId=' + id + '&pageNo=' + page + '&pageSize=10';
    return this.http.get(url, { headers });
  }

  getMedicines(id: any, date: any, isEdit: boolean) {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + 'medicines?memberId=' + id + '&date=' + date + '&isEdit=' + isEdit;
    return this.http.get(url, { headers });
  }

  addMedicine(payload: any) {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + 'medicines';
    return this.http.post(url, payload, { headers }).pipe(
      map((response) => response),
      catchError((error) => {
        console.log("Error while adding medicine: ", error);
        return of(1);
      }),
    );
  }
  getMemberMealPlan(id: any, filter: any, page: any) {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + 'mealplan/GetMemberMealPlanHistory?memberId=' + id + '&pageNo=' + page + '&pageSize=10&status=' + filter + '';
    return this.http.get(url, { headers });
  }
  uploadFile(formData: any) {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + 'LabWork';
    return this.http.post(url, formData, { headers });
  }
  getActivityMemberById(id: string, sdate: string, edate: string): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = `${this.apiBaseUrl}healthData/activitybyMemberId?memberId=${id}&startDate=${sdate}&endDate=${edate}`;
    return this.http.get(url, { headers });
  }
  getWorkoutActivityMemberById(id: string, sdate: string, edate: string): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = `${this.apiBaseUrl}healthData/getworkoutacivity?memberId=${id}&startDate=${sdate}&endDate=${edate}`;
    return this.http.get(url, { headers });
  }
  updateMedicine(obj:any) {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + 'medicines';
    return this.http.put(url,obj, { headers }).pipe(
      map((response) => response),
      catchError((error) => {
        console.log("Error while updating medicine: ",error);
          return of(1);
        
      }),
    );
  }
  deleteMedicine(id:any,date:any) {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + 'medicines'+`?id=${id}&curDate=${date}`;
    return this.http.delete(url, { headers }).pipe(
      map((response) => response),
      catchError((error) => {
        console.log("Error while deleting medicine: ",error);
          return of(1); 
      }),
    );
  }

  updateMedicineStatus(payload: any) {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + 'medicines/status';
    return this.http.put(url, payload, { headers }).pipe(
      map((response) => response),
      catchError((error) => {
        console.log("Error while updating medicine status: ", error);
        return of(1);
      }),
    );
  }

  getMemberBloodReport(memberId: string, pageNo: number = 1, pageSize: number = 10): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = `${this.apiBaseUrl}MemberBloodReport?MemberId=${memberId}&PageNo=${pageNo}&PageSize=${pageSize}`;
    return this.http.get(url, { headers });
  }

  getBiweeklyReports(memberId: string, pageNo: number = 1, pageSize: number = 10): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = `${this.apiBaseUrl}biweeklyreports?memberId=${memberId}&PageNo=${pageNo}&PageSize=${pageSize}`;
    return this.http.get(url, { headers });
  }

  getBiweeklyReportsLatest(memberId: string): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = `${this.apiBaseUrl}biweeklyreports/latest?memberId=${memberId}`;
    return this.http.get(url, { headers });
  }

  getMemberIssues(memberId: string): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = `${this.apiBaseUrl}members-issues/GetByMemberId?MemberId=${memberId}`;
    return this.http.get(url, { headers });
  }

  // Save or update progress notes
  saveProgressNotes(progressNotesData: any): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = `${this.apiBaseUrl}members-issues`;
    return this.http.post(url, progressNotesData, { headers });
  }

  // Update existing progress notes
  updateProgressNotes(id: string, progressNotesData: any): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = `${this.apiBaseUrl}members-issues/${id}`;
    return this.http.put(url, progressNotesData, { headers });
  }


  // Meeting Notes APIs
  getMeetingNotesByMemberId(memberId: string): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = `${this.apiBaseUrl}members-meeting-summary/GetByMemberId?memberId=${memberId}`;
    return this.http.get(url, { headers });
  }

  saveMeetingNote(meetingNoteData: any): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = `${this.apiBaseUrl}members-meeting-summary`;
    const loggedInUser = this.sharedService.getLoggedInUser();
    const payload = {
      ...meetingNoteData,
      userLoggedIn: loggedInUser?.id ?? ''
    };
    return this.http.post(url, payload, { headers });
  }

  updateMeetingNote(id: string, meetingNoteData: any): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = `${this.apiBaseUrl}members-meeting-summary/${id}`;
    const loggedInUser = this.sharedService.getLoggedInUser();
    const payload = {
      ...meetingNoteData,
      userLoggedIn: loggedInUser?.id ?? ''
    };
    return this.http.put(url, payload, { headers });
  }

  deleteMeetingNote(id: string): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = `${this.apiBaseUrl}members-meeting-summary/${id}`;
    return this.http.delete(url, { headers });
  }

  // HbA1c Log APIs
  getHbA1cLogsByMemberId(memberId: string, pageNo: number, pageSize: number): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = `${this.apiBaseUrl}members-hba1c-log?memberId=${memberId}&pageNo=${pageNo}&pageSize=${pageSize}`;
    return this.http.get(url, { headers });
  }

  createHbA1cLog(hbA1cLogData: any): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = `${this.apiBaseUrl}members-hba1c-log`;
    const loggedInUser = this.sharedService.getLoggedInUser();
    const payload = {
      ...hbA1cLogData,
      userLoggedIn: loggedInUser?.id ?? ''
    };
    return this.http.post(url, payload, { headers });
  }

  updateHbA1cLog(id: string, memberId: string, changedFields: any): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = `${this.apiBaseUrl}members-hba1c-log?id=${id}&memberId=${memberId}`;
    const loggedInUser = this.sharedService.getLoggedInUser();
    const payload = {
      ...changedFields,
      userLoggedIn: loggedInUser?.id ?? ''
    };
    return this.http.put(url, payload, { headers });
  }

  deleteHbA1cLog(id: string, memberId: string): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = `${this.apiBaseUrl}members-hba1c-log?id=${id}&memberId=${memberId}`;
    return this.http.delete(url, { headers });
  }

  updateLeaderBoardSetting(memberId: string, isLeaderBoard: number): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = `${this.apiBaseUrl}members/UpdateLeaderboardSetting`;
    const payload = {      
      memberId: memberId,
      showLeaderBoard: isLeaderBoard == 1 ? true : false
    
    };
    return this.http.post(url, payload, { headers });
  }

  getLeaderboardSetting(memberId: string): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = `${this.apiBaseUrl}members/leaderboardSetting?memberId=${memberId}`;
    return this.http.get(url, { headers });
  }

  getMemberOnboardingQuestions(memberId: string): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = `${this.apiBaseUrl}members/GetMemberQuestions?memberId=${memberId}`;
    return this.http.get(url, { headers });
  }

  updateMemberOnboardingAnswers(memberId: string, answers: Array<{questionId: string; questionType: string; answer: string}>): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = `${this.apiBaseUrl}members/UpdateMemberQuestions?memberId=${memberId}`;
    return this.http.put(url, answers, { headers });
  }

  getMemberPlanStatus(memberId: string): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = `${this.apiBaseUrl}members/GetMemberPlanStatus?memberId=${memberId}`;
    return this.http.get(url, { headers });
  }
}
